/**
 * Helpers for the rich-text comment body the API stores and returns.
 */

/**
 * Whether a comment has anything worth posting. Markup alone is not content —
 * an editor left untouched still emits `<p><br></p>` — but an attachment link or
 * an embedded image counts even with no text beside it.
 */
export function hasRichTextContent(html) {
  if (!html) return false;
  const { body } = new DOMParser().parseFromString(html, "text/html");
  return Boolean(body.textContent?.trim() || body.querySelector("img, a"));
}
